// extracted by mini-css-extract-plugin
export default {"div-hero":"Hero_div-hero__7alfy","div-hero-text":"Hero_div-hero-text__5Bof0","hero-h1":"Hero_hero-h1__qa7pf","hero-downward-arrow":"Hero_hero-downward-arrow__8dVpR"};